export default "__VITE_ASSET__DVIfgqhU__"